import { User } from '../../apis/graphql/types';

export const userByOrganization: Pick<
  User,
  'assignments' | 'email' | 'firstName' | 'lastName' | 'id' | 'phone' | 'roleList' | 'status'
> = {
  id: 'user-id-2',
  firstName: 'John',
  lastName: 'Doe',
  email: 'JohnDoe@disney.com',
  phone: '+1 (123) 456-7890',
  roleList: [
    {
      role: 'Organization Admin',
      entityId: '578cc416-8fba-4694-a264-c54519094766',
      entityType: 'MARKETER_ORGANIZATION',
      entityName: {
        id: '578cc416-8fba-4694-a264-c54519094766',
      },
    },
  ],
  status: 'ACTIVE',
  assignments: [
    {
      adAccountId: '-',
      adAccountName: 'All',
      assignment: 'ORGANIZATION_ADMIN',
    },
  ],
};
